import About from "../../Componant4/About/About";
import Appointment from "../../Componant4/Appointment/Appointment";
import Banner from "../../Componant4/Banner/Banner";
import Faq from "../../Componant4/Faq/Accordion/Faq";
import Blog from "../../Componant4/Blog/Blog";
import Feature from "../../Componant4/Feature/Feature";
import Service from "../../Componant4/Service/Service";
import Portfolio from "../../Componant4/Project/Project";
import TeamMember from "../../Componant4/TeamMember/TeamMember";
import Testimonial from "../../Componant4/Testimonial/Testimonial";
import WhyChoose from "../../Componant4/WhyChoose/WhyChoose";
import Counter from "../../Componant4/Counter/Counter";
import ContentSlider3 from "../../Componant4/ContentSlider3/ContentSlider3";

const Home4 = () => {
  return (
    <>
      <Banner />
      <Feature />
      <About />
      <Service />
      <Portfolio />
      <WhyChoose />
      <Counter />
      <Testimonial />
      <TeamMember />
      <Faq />
      <Blog />
      <Appointment />
      <ContentSlider3 />
    </>
  );
};
export default Home4;
